import state from "./State";
import mutations from "./Mutations";
import actions from "./Actions";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
